export default {
    translation: {
        title: "アメリカ",
        applications: "アプリケーション",
        full_text: "全文",
        vehicle: {
            status: "{{direction}}方向に時速{{speed}}マイルで走行中"
        },
        talkie: {
            drivers_nearby_singular: "近くのドライバーが1人います",
            drivers_nearby_plural: "近くのドライバーが{{count}}人います"
        },
        settings: {
            save_progress_description:
                "バックアップや他のコンピュータへの移行のために、フロッピーディスクに進捗を保存します。",
            save_progress_action: "進捗を保存",
            load_progress_action: "進捗を読み込み...",
            display_units: "表示単位",
            imperial: "ヤード・ポンド法",
            metric: "メートル法",
            start_over_description:
                "旅を早めに終了します。現在の進捗は消去されます。この操作は元に戻せません。",
            start_over_action: "やり直す"
        },
        feedback: {
            message: "メッセージ",
            contact_info: "連絡先（任意）",
            send: "送信",
            sending: "送信中..."
        },
        radio: {
            no_reception: "この地域ではラジオを受信できません",
            low_signal: "電波が弱い",
            turn_off: "電源オフ",
            turn_on: "電源オン",
            next_station: "次の局",
            unmute: "ミュート解除",
            mute: "ミュート"
        },
        photos: {
            source: "Mapillary提供",
            empty: "写真を撮るために周囲を探索中..."
        },
        news: {
            loading: "地域のニュースを確認中...",
            nothing_found: "見つかりませんでした。"
        },
        metrics: {
            duration_title: "運転時間",
            duration_value: "{{days}}日{{hours}}時間{{minutes}}分",
            distance_title: "移動距離",
            emissions_title: "排気ガスCO2",
            emissions_value_g: "{{g}}g",
            emissions_value_kg: "{{kg}}kg",
            states_visited_title: "訪問した州",
            cairns_discovered_title: "発見されたケアン",
            exploration_title: "探検"
        },
        compass: {
            north_east: "北東",
            east: "東",
            south_east: "南東",
            south: "南",
            south_west: "南西",
            west: "西",
            north_west: "北西",
            north: "北"
        },
        landing: {
            about_title: "概要",
            start_title: "スタート",
            features_title: "特徴",
            about_headline: "アメリカ：ブラウザで楽しむロードトリップシミュレーター",
            about_paragraph_1:
                "Safari、Chrome、Edge。これらはウェブの無限の隅へのゲートウェイです。\n"
                + "Americaは、別の種類の広大な地形へのあなたのゲートウェイです：アメリカ合衆国の\n"
                + "自然の驚異。あなた自身のペースで、学ぶべきことがたくさんあります。",
            about_paragraph_2:
                "壮大な景観から静かな路地の瞬間まで、デスクトップ風のウィンドウ型インターフェースで\n"
                + "旅を操縦します：マップ、ライブラジオ、百科事典の記事、カメラロール、メトリクス、\n"
                + "ジャーナルなど。スコアボードなし、急がなくていい：偶然の発見と雰囲気が最優先。\n"
                + "最新のブラウザで開くだけで、インストールは不要です。",
            about_paragraph_3:
            "旅のルートは自由です。パシフィック・コースト・ハイウェイ、平原を横切るルート66、"
                + "ロッキー山脈から国立公園へ、ニューイングランドの脇道まで。立ち寄るたびに、その"
                + "場所の物語が開きます：この街、渓谷、展望台が何を見てきたか、ラジオで何が流れて"
                + "いるか、今の天気はどうか。自分のペースでアメリカを探索できる、ブラウザで動く"
                + "ロードトリップシミュレーターです。",

            trips_title: "旅で探す",
            trips_list: [
                { label: "バーチャルロードトリップ", url: "/virtual-road-trip/" },
                { label: "アメリカ横断の旅", url: "/us-road-trip/" },
                { label: "国立公園の旅", url: "/national-parks-road-trip/" },
                { label: "ルート66の旅", url: "/route-66-road-trip/" },
                { label: "アメリカを探索", url: "/explore-america/" },
                { label: "アメリカ横断ロードトリップ", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "CMを見る",
            start_cta: "旅を始める",
            start_cta_lead: "インストール不要。ブラウザで動作します。",
            features_lede:
                "旅が始まると、Americaのロードトリップスイートからダッシュボードを設定します。\n"
                + "各ウィンドウは国を体験する異なる方法です。地元のラジオから他のドライバーとの\n"
                + "トランシーバーまで、旅のたびに何か新しいものを見つけるでしょう。",
            features_list: [
                "米国全体をルーティングと探検できるマップ",
                "ストリーミングラジオと場所に紐づく記事＆写真",
                "ジャーナル、メトリクス、カメラロール、百科事典",
                "友達、ボイスチャット、共有された路傍のランドマーク（ケアン）",
                "電話でもデスクトップでもブラウザで動作；ダウンロード不要"
            ],
            media_alt: "America Complete Edition：ソフトウェアボックスとCD",
            slideshow_alt: "アメリカシミュレーターのロードトリップ風景写真、画像",
            og_title: "America：ロードトリップシミュレーター",
            og_description:
                "デスクトップ風の楽しいロードトリップシミュレーターで、アメリカ合衆国の自然の驚異を探索しましょう。マップ、ラジオ、ジャーナル、そして偶然の発見が、ブラウザ上で直接楽しめます。",
            twitter_description:
                "デスクトップ風の楽しいロードトリップシミュレーターで、アメリカ合衆国の自然の驚異を探索しましょう。インストール不要。",
            meta_description:
                "Americaはブラウザのロードトリップシミュレーターです：マップ、ラジオ、写真、デスクトップ風のインターフェースで、アメリカ合衆国の自然の驚異を自分のペースで探索。ダウンロード不要；オンラインで旅を始めましょう。",
            jsonld_description:
                "Americaはブラウザのロードトリップシミュレーターです：マップ、ラジオ、写真、デスクトップ風のインターフェースで、アメリカ合衆国の自然の驚異を自分のペースで探索。ダウンロード不要；オンラインで旅を始めましょう。",
            jsonld_genre: ["ロードトリップシミュレーター", "探検ゲーム", "ブラウザゲーム"],
            page_title: "America：ロードトリップシミュレーター | ブラウザでアメリカを探索",
            html_lang: "ja",
            og_locale: "ja_JP",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "de_DE", "ru_RU", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "ロードトリップシミュレーター America のスクリーンショット",
            twitter_image_alt: "ロードトリップシミュレーター America のスクリーンショット",
        },
    }
};
